import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { DateRangePickerComponentProps } from "../../components/DateRangePickerComp";
import { useGlobal } from "../../components/GlobalProviderLayout";
import { DateRange, RESET_DATE_RANGE, SET_DATE_RANGE } from "../../components/GlobalProviderLayout/GlobalProviderLayoutModel";
import { buildPrivatePdfLink } from "../../utils/buildPrivatePdfLink";
import { PayrollHistory } from "./PayrollHistory";

export const PayrollHistoryRoute = () => {
  const today = dayjs();
  const lastSaturdayDate = today.subtract(today.day() >= 4 ? 1 : 2, 'week').endOf('week');
  const lastSundayDate = lastSaturdayDate.subtract(6, 'days')
  const navigate = useNavigate();
  const { state, dispatch } = useGlobal();
  const [dateError, setDateError] = useState<(string | null)[]>(['', '']);
  const [showDetailsChecked, setShowDetailsChecked] = useState(false);
  const [startDate, endDate] = state.dateRange;
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const disabledView = !startDate || !endDate || !!dateError[0] || !!dateError[1];
  const formattedDate = (date: Dayjs | null) => dayjs(date).format('DDMMYYYY');
  const onView = () => navigate(`/payroll-history-results/${formattedDate(startDate)}/${formattedDate(endDate)}`);

  useEffect(() => {
    if (!state.previousLocation?.includes('/payroll-history')) {
      dispatch({ type: RESET_DATE_RANGE })
    }
  }, [dispatch, state.previousLocation])

  useEffect(() => {
    if (!startDate && !endDate) {
      dispatch({ type: SET_DATE_RANGE, payload: [lastSundayDate, lastSaturdayDate] });
    }
  }, [lastSundayDate, lastSaturdayDate, dispatch, startDate, endDate])

  const handleDateChange = (date: Dayjs | null, isStart = true) => {
    const start = isStart ? date : state.dateRange[0];
    const end = isStart ? state.dateRange[1] : date;
    const payload: DateRange = [start, end];
    dispatch({ type: SET_DATE_RANGE, payload });
  }

  const dateRangePickerComponentProps: DateRangePickerComponentProps = {
    onError: setDateError,
    startDate,
    endDate,
    handleDateChange,
    error: dateError,
    dataAutomation: {
      startDateInput: 'start-input',
      endDateInput: 'end-input',
      invalidDateMsg: 'invalid-date-msg'
    },
    minDate: dayjs('2002-01-01'),
    minDateErrorMsg: 'Payroll Information is available from Jan 1, 2002 onward only.'
  };

  const onRunReport = () => {
    const reportKey = showDetailsChecked ? 'PayrollHistoryDetail' : 'PayrollHistorySummary';
    const url = buildPrivatePdfLink(`/reports/payroll-history/${reportKey}/${formattedDate(startDate)}/${formattedDate(endDate)}`);
    window.open(url, '_blank')
  };

  const onShowDetails = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    setShowDetailsChecked(prev => prev !== e.target.checked ? e.target.checked : prev);
  }

  const onShowDisclaimer = () => setShowDisclaimer(prev => !prev);
  return (
    <PayrollHistory
      showDisclaimer={showDisclaimer}
      onShowDisclaimer={onShowDisclaimer}
      dateRangePickerComponentProps={dateRangePickerComponentProps}
      onView={onView}
      disabledView={disabledView}
      onRunReport={onRunReport}
      showDetailsChecked={showDetailsChecked}
      onShowDetails={onShowDetails}
    />
  )
}